import React from "react";
import { Button } from "@culturehq/components";

import { t, Trans } from "app/utils";

import { TimeDiff } from "components/common/Time";
import SurveyCompleted from "components/survey/SurveyCompleted";

const CompletedSurveys = ({ surveys }) => {
  if (surveys.length === 0) {
    return t("No completed surveys with results");
  }

  return surveys.map(survey => (
    <>
      <SurveyCompleted key={survey.id} survey={survey}>
        {onTrigger => (
          <Button icon="stats-bars" inverted onClick={onTrigger}>
            <Trans>Results</Trans>
          </Button>
        )}
      </SurveyCompleted>
      <div className="widget-surveys--survey">
        {survey.title}
        <br />
        <small>
          <TimeDiff time={survey.activeModifiedAt} />
        </small>
      </div>
    </>
  ));
};

export default CompletedSurveys;
